module.exports = __webpack_public_path__ + "img/DSC_1087.693f1d5b.jpg";